
export default {

  actionGetAddress (context) {
    context.commit('GET_ADDRESS');
  },
  
  actionGetStations (context, params) {
    context.commit('GET_STATIONS', params);
  },

  actionGetTasks (context) {
    context.commit('GET_TASKS');
  },

  actionGetConfigurations (context) {
    context.commit('GET_CONFIGURATIONS');
  },

  actionGetBackups (context) {
    context.commit('GET_BACKUPS');
  },

  actionGetUsers (context) {
    context.commit('GET_USERS');
  }

}
